import type { PocInputValidity } from 'commons/types';
import { ErrorMapping } from 'core/types/error-mapping';
import {
    areThresholdsValid,
    getMonitoringPeriodValidity,
    getNameValidity,
    isMonitoringPeriodValid,
} from 'modules/settings/components/custom-notifications/custom-notification-form.validation';
import { CustomAlarmFormState } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.model';

export const getCustomAlarmsFormValidation = (form: CustomAlarmFormState, submitAttempted: boolean) => {
    const nameValid = form.name.trim().length > 0;
    const eventsValid = form.selectedEventIds.length > 0;
    const windowDaysValid = isMonitoringPeriodValid(form.windowDays);
    const formValid = nameValid && eventsValid && windowDaysValid && areThresholdsValid(form.notifications);

    const windowDaysValidity = getMonitoringPeriodValidity(form.windowDays, submitAttempted);

    const getNameInputError = (nameCustomValidationCode?: ErrorMapping['type']): PocInputValidity | undefined =>
        getNameValidity(nameValid, submitAttempted, nameCustomValidationCode);

    return {
        nameValid,
        eventsValid,
        formValid,
        windowDaysValidity,
        getNameInputError,
    };
};
